export enum ESearchBarFeatures {
    Buy = 'buy',
    Rent = 'rent',
    PropertyValue = 'property-value',
    HomeService = 'home-service',
    FindAgents = 'find-agents',
}
